import React, { FunctionComponent, useState } from 'react';

import { ImageProps } from 'src/components/image';

import {
  StyledContainer,
  StyledImageContainer,
  StyledPicture,
  StyledArrowColumn,
  StyledArrowLeft,
  StyledArrowRight,
  StyledNavigationItem,
  StyledNavigationRow,
  StyledImageWrapper,
  StyledImage,
} from './images-slider.styled';

interface Props {
  images: ImageProps[];
}

export const ImagesSlider: FunctionComponent<Props> = (props) => {
  const [selectedItem, setSelectedItem] = useState(0);
  const { images, ...rest } = props;

  const handleSelectPrevious = (): void => setSelectedItem((previousState) => previousState - 1);
  const handleSelectNext = (): void => setSelectedItem((previousState) => previousState + 1);

  if (images.length === 1) {
    return <StyledImage {...images[0]} />;
  }

  return (
    <StyledContainer {...rest}>
      <StyledArrowColumn>{selectedItem !== 0 && <StyledArrowLeft onClick={handleSelectPrevious} />}</StyledArrowColumn>
      <StyledImageContainer>
        <StyledImageWrapper>
          <StyledPicture {...images[selectedItem]} />
        </StyledImageWrapper>
        <StyledNavigationRow>
          {images.map((image, index) => (
            <StyledNavigationItem key={index} $active={index === selectedItem} onClick={() => setSelectedItem(index)} />
          ))}
        </StyledNavigationRow>
      </StyledImageContainer>
      <StyledArrowColumn>
        {images.length - 1 !== selectedItem && <StyledArrowRight onClick={handleSelectNext} />}
      </StyledArrowColumn>
    </StyledContainer>
  );
};
